import { useState } from "react";
import { FormControl } from "react-bootstrap";
import { useMasterContext } from "provider/MasterProvider";
import Select from 'react-select';
import { useParksViewContext } from "provider/ParkViewProvider";
import rupeeFormat from "components/Api/RupeeFormat";

const ParkShareSafariFilter = () => {
  const { safariFilters, parksViewDispatch } = useParksViewContext();
  const { months, safariType, safariAgenda, safariCategory, safariHostType } = useMasterContext();
  const [budgetMin, setBudgetMin] = useState(0);
  const [budgetMax, setBudgetMax] = useState(50000);
  const [safarisMin, setSafarisMin] = useState(1);
  const [safarisMax, setSafarisMax] = useState(10);

  const updateFilter = (name, value) => {
    parksViewDispatch({
      type: "UPDATE_PARKS_VIEW_SAFARI_FILTER",
      payload: { [name]: value },
    });
  };

  return (
    <div className="filter-wrapper d-lg-block d-none p-3 ">
      <div className="title_top pb-4">
        <h4>Select Filters</h4>
      </div>
      <div className="title_filter mb-3">
        <h6>Month</h6>
        <Select
          value={months?.find(p => p.value === safariFilters?.month_id) || null}
          onChange={(selectedOption) => updateFilter('month_id', selectedOption?.value || 0)}
          options={months}
          isSearchable
          isClearable
          components={{ IndicatorSeparator: () => null }}
        />
      </div>

      <div className="title_filter mb-3">
        <h6>Type</h6>
        <div className="input_check ">
          {safariType.map(type => (
            <div className="d-flex align-items-center pt-1" key={type.value}>
              <input
                type="checkbox"
                className="type checkbox_design me-3"
                name="type"
                id={`type-${type.value}`}
                value={type.value}
                checked={Array.isArray(safariFilters?.type) && safariFilters?.type.includes(type.value)}
                onChange={(e) => {
                  const checked = e.target.checked;
                  const current = safariFilters?.type || [];
                  const newValues = checked
                    ? [...current, type.value]
                    : current.filter(v => v !== type.value);
                  updateFilter("type", newValues);
                }}
              />
              <label htmlFor={`type-${type.value}`}>{type.label}</label>
            </div>
          ))}
        </div>
      </div>

      <div className="title_filter mb-3">
        <h6>Budget Price Per Person</h6>
        <div className="multi-range">
          <FormControl
            type="range"
            step="100"
            min={1000}
            max={50000}
            value={safariFilters?.estimate_price_min || 1000}
            onChange={(e) => {
              const val = Number(e.target.value);
              const max = safariFilters?.estimate_price_max || 50000;
              const newMin = Math.min(val, max - 100);
              setBudgetMin(newMin);
              updateFilter("estimate_price_min", newMin);
            }}
            className="dual_range range_values"
            name="estimate_price_min"

          />
          <FormControl
            type="range"
            step="100"
            min={1000}
            max={50000}
            value={safariFilters?.estimate_price_max || 50000}
            onChange={(e) => {
              const val = Number(e.target.value);
              const min = safariFilters?.estimate_price_min || 1000;
              const newMax = Math.max(val, min + 100);
              setBudgetMax(newMax);
              updateFilter("estimate_price_max", newMax);
            }}
            className="dual_range range_values"
            name="estimate_price_max"
          />
        </div>
        <div className="range-label">
          <span className="value">₹{rupeeFormat(Math.max(safariFilters?.estimate_price_min || 0, 1000))} </span>
          <span className="float-end">₹{budgetMax >= 50000 ? "50,000+" : rupeeFormat(Math.max(safariFilters?.estimate_price_max || 50000, 0))} </span>
        </div>
      </div>

      <div className="title_filter mb-3">
        <h6>Total Safaris</h6>
        <div className="multi-range">
          <FormControl
            type="range"
            min="1"
            max="10"
            value={Math.max(safariFilters?.no_of_safari_min || 0, 1)}
            onChange={(e) => {
              const val = Number(e.target.value);
              const max = safariFilters?.no_of_safari_max || 10;
              if (val <= max) {
                setSafarisMin(val);
                updateFilter("no_of_safari_min", val);
              }
            }}
            className="dual_range range_values"
            name="no_of_safari_min"
          />
          <FormControl
            type="range"
            min="1"
            max="10"
            value={Math.max(safariFilters?.no_of_safari_max || 10, 1)}
            onChange={(e) => {
              const val = Number(e.target.value);
              const min = safariFilters?.no_of_safari_min || 1;
              if(val >= min) {
                setSafarisMax(val);
                updateFilter("no_of_safari_max", val);
              }
            }}
            className="dual_range range_values"
            name="no_of_safari_max"
          />
        </div>
        <div className="range-label">
          <span className="value">{Math.max(safariFilters?.no_of_safari_min || 0, 1)} </span>
          <span className="float-end">{Math.max(safariFilters?.no_of_safari_max || 10, 1)}+ </span>
        </div>
      </div>

      <div className="title_filter mb-3">
        <h6>Theme</h6>
        <div className="input_check ">
          {safariAgenda.map(theme => (
            <div className="d-flex align-items-center pt-1" key={theme.value}>
              <input
                type="checkbox"
                className="type checkbox_design me-3"
                name="share_safari_agenda_id"
                id={`share_safari_agenda-${theme.value}`}
                value={theme.value}
                checked={Array.isArray(safariFilters?.share_safari_agenda_id) && safariFilters?.share_safari_agenda_id.includes(theme.value)}
                onChange={(e) => {
                  const checked = e.target.checked;
                  const current = safariFilters?.share_safari_agenda_id || [];
                  const newValues = checked
                    ? [...current, theme.value]
                    : current.filter(v => v !== theme.value);
                  updateFilter("share_safari_agenda_id", newValues);
                }}
              />
              <label htmlFor={`share_safari_agenda-${theme.value}`}>{theme.label}</label>
            </div>
          ))}
        </div>
      </div>

      <div className="title_filter mb-3">
        <h6>Organizer</h6>
        <div className="input_check ">
          {safariHostType.map(org => (
            <div className="d-flex align-items-center pt-1" key={org.value}>
              <input
                type="checkbox"
                className="type checkbox_design me-3"
                name="host_type"
                id={`host-type-${org.value}`}
                value={org.value}
                checked={Array.isArray(safariFilters?.host_type) && safariFilters?.host_type.includes(org.value)}
                onChange={(e) => {
                  const checked = e.target.checked;
                  const current = safariFilters?.host_type || [];
                  const newValues = checked
                    ? [...current, org.value]
                    : current.filter(v => v !== org.value);
                  updateFilter("host_type", newValues);
                }}
              />
              <label htmlFor={`host-type-${org.value}`}>{org.label}</label>
            </div>
          ))}
        </div>
      </div>

      <div className="title_filter mb-3">
        <h6>Stay Category</h6>
        <div className="input_check ">
          {safariCategory.map(budget => (
            <div className="d-flex align-items-center pt-1" key={budget.value}>
              <input
                type="checkbox"
                className="type checkbox_design me-3"
                id={`stay-category-${budget.value}`}
                name="stay_category_id"
                value={budget.value}
                checked={Array.isArray(safariFilters?.stay_category_id) && safariFilters?.stay_category_id?.includes(budget.value)}
                onChange={(e) => {
                  const checked = e.target.checked;
                  const current = safariFilters?.stay_category_id || [];
                  const newValues = checked
                    ? [...current, budget.value]
                    : current.filter(v => v !== budget.value);
                  updateFilter("stay_category_id", newValues);
                }}
              />
              <label htmlFor={`stay-category-${budget.value}`}>{budget.label}</label>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ParkShareSafariFilter;
